import { get } from './utils';

const retrieve_reservation_setting = async (
    callback: ((data: any) => void) | null = null
): Promise<void> => {
    const path = '/reservation_setting/retrieve';
    const result = await get(path);
    console.debug('retrieve_reservation_setting', result);
    if (callback !== null) {
        callback(result?.data);
    } else return result?.data;
};

export { retrieve_reservation_setting };
